import { fetchFavoriteDances } from "../api.js";

export async function loadState(eventId, { dancerId, occurrenceDate, signal } = {}) {
  return fetchFavoriteDances(eventId, { dancerId, occurrenceDate, signal });
}
